export const ROLE_FORM_DATA = 'ROLE_FORM_DATA'
export const DEPARTMENT_DATA = 'DEPARTMENT_DATA'
